<template>
    <div class="relative z-[99999]" aria-labelledby="modal-title" role="dialog" aria-modal="true">
        <div class="fixed inset-0 bg-black bg-opacity-25 backdrop-blur-sm transition-opacity"></div>
        <div class="fixed inset-0 z-30 overflow-y-auto">
            <div class="flex min-h-full items-end px-4 pb-16 text-center max-w-lg mx-auto">
                <div
                    class="border-2 border-jackpot-bg flex-1 relative transform overflow-hidden rounded-lg text-left drop-shadow-xl transition-all">
                    <div class="bg-white dark:bg-global-bg p-4 modalheight overflow-y-auto">

                        <div class="text-center mb-2">
                            <h3 class="text-lg font-medium leading-6 text-gray-900 dark:text-gray-50">Swap Gems</h3>
                            <p>You'll be able to swap gems here!</p>
                            <p class="text-xs text-inner-border">It's a slow process, so hang in there!</p>
                            <p class="text-sm text-green-500 font-semibold flex items-center justify-center gap-2 mt-2"
                                v-if="status !== ''">
                                <span>{{ status }}</span>
                                <spinner v-if="!status.startsWith('Swap succesful')" class="text-green-500" />
                            </p>
                            <p class="text-sm text-red-500 font-semibold flex items-center justify-center gap-2 mt-2"
                                v-if="statusError !== ''">
                                <span>{{ statusError }}</span>
                            </p>
                            <p class="text-sm text-transparent font-semibold flex items-center justify-center gap-2 mt-2"
                                v-if="statusError == '' && status == ''">
                                <span>&nbsp;</span>
                            </p>
                        </div>

                        <div class="flex flex-col items-center gap-2">

                            <div class="w-full flex items-center justify-between"
                                :class="fetchingTokens || swapping || topaz.length < 3 ? 'opacity-50' : ''">
                                <div class="flex items-center">
                                    <div class="font-semibold text-lg">3</div>
                                    <i class="far fa-times fa-fw text-xs"></i>
                                    <img class="h-6 w-6 rounded drop-shadow-sm" src="/images/token_topaz.gif" />
                                    <i class="far fa-chevron-right fa-fw text-xs mx-1"></i>
                                    <img class="h-8 w-8 rounded drop-shadow-sm" src="/images/token_sapphire.gif" />
                                </div>
                                <div class="flex items-center gap-2">
                                    <div class="ml-2 text-xs">(Balance: {{ topaz.length }})</div>
                                    <button @click="swap('topaz')"
                                        :disabled="fetchingTokens || swapping || topaz.length < 3"
                                        class="bg-red-600 text-white rounded p-1 text-sm">
                                        <span v-if="!fetchingTokens || !swapping"
                                            class="uppercase text-xs font-semibold">Swap</span>
                                        <span v-else>
                                            <spinner />
                                        </span>
                                    </button>
                                </div>
                            </div>

                            <div class="w-full flex items-center justify-between"
                                :class="fetchingTokens || swapping || sapphire.length < 3 ? 'opacity-50' : ''">
                                <div class="flex items-center">
                                    <div class="font-semibold text-lg">3</div>
                                    <i class="far fa-times fa-fw text-xs"></i>
                                    <img class="h-6 w-6 rounded drop-shadow-sm" src="/images/token_sapphire.gif" />
                                    <i class="far fa-chevron-right fa-fw text-xs mx-1"></i>
                                    <img class="h-8 w-8 rounded drop-shadow-sm" src="/images/token_emerald.gif" />
                                </div>
                                <div class="flex items-center gap-2">
                                    <div class="ml-2 text-xs">(Balance: {{ sapphire.length }})</div>
                                    <button @click="swap('sapphire')"
                                        :disabled="fetchingTokens || swapping || sapphire.length < 3"
                                        class="bg-red-600 text-white rounded p-1 text-sm">
                                        <span v-if="!fetchingTokens || !swapping"
                                            class="uppercase text-xs font-semibold">Swap</span>
                                        <span v-else>
                                            <spinner />
                                        </span>
                                    </button>
                                </div>
                            </div>

                            <div class="w-full flex items-center justify-between"
                                :class="fetchingTokens || swapping || emerald.length < 3 ? 'opacity-50' : ''">
                                <div class="flex items-center">
                                    <div class="font-semibold text-lg">3</div>
                                    <i class="far fa-times fa-fw text-xs"></i>
                                    <img class="h-6 w-6 rounded drop-shadow-sm" src="/images/token_emerald.gif" />
                                    <i class="far fa-chevron-right fa-fw text-xs mx-1"></i>
                                    <img class="h-8 w-8 rounded drop-shadow-sm" src="/images/token_ruby.gif" />
                                </div>
                                <div class="flex items-center gap-2">
                                    <div class="ml-2 text-xs">(Balance: {{ emerald.length }})</div>
                                    <button @click="swap('emerald')"
                                        :disabled="fetchingTokens || swapping || emerald.length < 3"
                                        class="bg-red-600 text-white rounded p-1 text-sm">
                                        <span v-if="!fetchingTokens || !swapping"
                                            class="uppercase text-xs font-semibold">Swap</span>
                                        <span v-else>
                                            <spinner />
                                        </span>
                                    </button>
                                </div>
                            </div>

                        </div>
                    </div>
                    <div class="bg-gray-50 dark:bg-global-bg px-4 py-3 flex flex-col">
                        <button @click.prevent="close" type="button" :disabled="fetchingTokens || swapping"
                            class="modal-cancel-button">Close</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios'
import { Connection, PublicKey, TransactionMessage, VersionedTransaction } from "@solana/web3.js"
import { bs58 } from "@project-serum/anchor/dist/cjs/utils/bytes/index.js"
import { SPL_ACCOUNT_COMPRESSION_PROGRAM_ID, SPL_NOOP_PROGRAM_ID } from "@solana/spl-account-compression"
import { createTransferInstruction, PROGRAM_ID as BUBBLEGUM_PROGRAM_ID } from "@metaplex-foundation/mpl-bubblegum"
import { useWallet } from 'solana-wallets-vue'

export default {
    name: 'SwapTokensModal',
    props: ['token'],
    data() {
        return {
            rpc: null,
            connection: null,
            tokens: [],
            fetchingTokens: false,
            swapping: false,
            status: '',
            statusError: ''
        }
    },
    async mounted() {
        this.rpc = process.env.MIX_TOKEN_RPC
        this.connection = new Connection(this.rpc)
        await this.fetchWalletTokens()
    },
    computed: {
        topaz() {
            return this.tokens.filter(item => item.compression.tree === process.env.MIX_TOKEN_TOPAZ)
        },
        sapphire() {
            return this.tokens.filter(item => item.compression.tree === process.env.MIX_TOKEN_SAPPHIRE)
        },
        emerald() {
            return this.tokens.filter(item => item.compression.tree === process.env.MIX_TOKEN_EMERALD)
        },
        ruby() {
            return this.tokens.filter(item => item.compression.tree === process.env.MIX_TOKEN_RUBY)
        }
    },
    methods: {
        async fetchWalletTokens(rpcUrl = process.env.MIX_TOKEN_RPC) {
            this.fetchingTokens = true
            const collection = process.env.MIX_TOKEN_COLLECTION
            const wallet = useWallet().publicKey.value.toString()
            let page = 1
            await axios.post(rpcUrl, {
                jsonrpc: '2.0',
                id: 'my-id',
                method: 'searchAssets',
                params: {
                    ownerAddress: wallet,
                    compressed: true,
                    grouping: ["collection", collection],
                    page: page, // Starts at 1
                    limit: 1000
                }
            }).then((response) => {
                this.tokens = response.data.result.items
            }).catch((err) => {
                console.log(err)
            }).finally(() => {
                this.fetchingTokens = false
            })
        },
        decode(stuff) {
            return this.bufferToArray(bs58.decode(stuff))
        },
        bufferToArray(buffer) {
            const nums = []
            for (let i = 0; i < buffer.length; i++) {
                nums.push(buffer[i])
            }
            return nums
        },
        mapProof(assetProof) {
            if (!assetProof.proof || assetProof.proof.length === 0) {
                throw new Error('Proof is empty');
            }
            return assetProof.proof.map((node) => ({
                pubkey: new PublicKey(node),
                isSigner: false,
                isWritable: false,
            }))
        },
        async getAssetProof(assetId, rpcUrl = process.env.MIX_TOKEN_RPC) {
            try {
                const response = await axios.post(rpcUrl, {
                    jsonrpc: "2.0",
                    method: "getAssetProof",
                    id: "my-id",
                    params: {
                        id: assetId
                    },
                });
                return response.data.result;
            } catch (error) {
                console.error(error);
            }
        },
        async getAssetsProof(assetIds, rpcUrl = process.env.MIX_TOKEN_RPC) {
            try {
                const response = await axios.post(rpcUrl, {
                    jsonrpc: "2.0",
                    method: "getAssetProofBatch",
                    id: "my-id",
                    params: {
                        ids: assetIds
                    },
                });
                return response.data.result;
            } catch (error) {
                console.error(error);
            }
        },
        async transferCNFTix(asset, signer, newOwner, assetsProof) {
            const [treeAuthority, _bump] = PublicKey.findProgramAddressSync(
                [asset.merkleTree.toBuffer()],
                BUBBLEGUM_PROGRAM_ID,
            )
            const canopyDepth = 8
            const proofPathAsAccounts = this.mapProof(assetsProof[asset.id]).slice(0, assetsProof[asset.id].proof.length - canopyDepth)

            return await createTransferInstruction({
                treeAuthority: treeAuthority,
                leafOwner: signer,
                leafDelegate: signer,
                newLeafOwner: newOwner,
                merkleTree: asset.merkleTree,
                logWrapper: SPL_NOOP_PROGRAM_ID,
                compressionProgram: SPL_ACCOUNT_COMPRESSION_PROGRAM_ID,
                anchorRemainingAccounts: proofPathAsAccounts
            },
                {
                    creatorHash: this.decode(asset.creator_hash),
                    dataHash: this.decode(asset.data_hash),
                    index: asset.leaf_id,
                    nonce: asset.leaf_id,
                    root: this.decode(assetsProof[asset.id].root)
                })
        },
        async createTx(instructions, signer, latestBlockhash) {
            const messageLegacy = new TransactionMessage({
                payerKey: signer,
                recentBlockhash: latestBlockhash.blockhash,
                instructions
            }).compileToLegacyMessage()
            return new VersionedTransaction(messageLegacy)
        },
        async createLookupTableTx(instructions, signer, latestBlockhash, lookupTableAccount) {
            const messageV0 = new TransactionMessage({
                payerKey: signer,
                recentBlockhash: latestBlockhash.blockhash,
                instructions: instructions,
            }).compileToV0Message([lookupTableAccount]);
            return new VersionedTransaction(messageV0);
        },
        async swap(type) {
            this.status = ''
            this.statusError = ''
            try {
                this.swapping = true

                const newOwner = new PublicKey(process.env.MIX_TOKEN_WALLET)
                const signer = useWallet().publicKey.value

                const tokens = this.$options.computed[type].call(this).slice(0, 3).map((token) => {
                    return {
                        id: token.id,
                        creator_hash: token.compression.creator_hash,
                        data_hash: token.compression.data_hash,
                        merkleTree: new PublicKey(token.compression.tree),
                        leaf_id: token.compression.leaf_id,
                    }
                })

                let ixs = []
                let lookupTableKeys = []
                let assetIds = []
                // Get Asset Proofs
                for (let index = 0; index < 3; index++) {
                    assetIds = tokens.map((item) => {
                        return item.id
                    })
                }

                this.status = 'Getting gems...'
                let assetsProof
                try {
                    assetsProof = await this.getAssetsProof(assetIds)
                } catch (err) {
                    throw new Error('Error Getting Assets Proof. Try again later...')
                }

                // Create Transfer Instructions
                for (let index = 0; index < 3; index++) {
                    const ix = await this.transferCNFTix(tokens[index], signer, newOwner, assetsProof)
                    const keys = ix.keys.map((key) => {
                        return key.pubkey.toBase58()
                    })
                    lookupTableKeys.push(...keys)
                    ixs.push(ix)
                }
                lookupTableKeys = [...new Set(lookupTableKeys)]

                this.status = 'Creating swap instruction...'
                let lookupTableAddress = null
                await window.axios.post('/api/account/lookup', { 'wallets': lookupTableKeys }, {
                    headers: {
                        'Authorization': `Bearer ${this.token}`
                    },
                    timeout: 120000
                })
                    .then((res) => {
                        lookupTableAddress = new PublicKey(res.data.table)
                    }).catch((err) => {
                        console.log(err.message)
                        throw new Error('Error creating swap instruction. Try again later...')
                    })

                await new Promise(resolve => setTimeout(resolve, 1000))

                this.status = 'Getting addresses...'
                let lookupTableAccount
                try {
                    lookupTableAccount = await this.connection.getAddressLookupTable(lookupTableAddress, {
                        commitment: 'confirmed'
                    }).then((res) => res.value);
                } catch (err) {
                    console.log(err.message)
                    throw new Error('Error getting addresses. Try again later...')
                }

                this.status = 'Getting latest blockash...'
                let latestBlockhash
                try {
                    latestBlockhash = await this.connection.getLatestBlockhash()
                } catch (err) {
                    console.log(err.message)
                    throw new Error('Error getting latest blockash. Try again later...')
                }

                this.status = 'Generating transaction...'
                let tx
                try {
                    tx = await this.createLookupTableTx(ixs, signer, latestBlockhash, lookupTableAccount)
                } catch (err) {
                    console.log(err.message)
                    throw new Error('Error generating transaction. Try again later...')
                }

                this.status = 'Waiting for wallet to sign...'
                const { sendTransaction } = useWallet()
                let signature
                try {
                    signature = await sendTransaction(tx, this.connection, { preflightCommitment: 'confirmed' })
                    console.log('tx:', signature)
                } catch (err) {
                    console.log(err.message)
                    throw new Error(err.message)
                }

                let confirmed = false

                this.status = 'Confirming swap...'
                try {
                    window.axios.post('/api/account/swap/confirm', {
                        'tx': signature,
                        'confirmed': confirmed,
                        'table': lookupTableAddress.toString(),
                        'type': type
                    }, {
                        headers: {
                            'Authorization': `Bearer ${this.token}`
                        }
                    })
                } catch (err) {
                    console.log(err.message)
                    throw new Error('Error confirming swap. Try again later...')
                }
                this.status = 'Swap succesful, the new gem will be soon in your wallet.'

                await new Promise(resolve => setTimeout(resolve, 1000))

                await this.fetchWalletTokens()
            } catch (err) {
                this.status = ''
                this.statusError = err.message
            } finally {
                this.swapping = false
            }
        },
        close() {
            this.emitter.emit('close-modal', 'swap_tokens_modal')
        }
    }
}
</script>
